var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4 bg-white rounded-lg h-100"},[_c('iframe',{ref:"iframe",staticClass:"custom-content-height",staticStyle:{"width":"100% !important"},attrs:{"src":"https://backend.iqfulfillment.com/iq_ai","frameborder":"0","width":"100%","height":"100%"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }